

<span class="front-sub-5 font-size-11 font-medium center-icon flinker-date-format">
  {{ !showFullText && jobDutiesDescription.length > 100 ? (jobDutiesDescription | truncate:[100, '...']) :
  jobDutiesDescription }} <span class='text-colour' (click)='showText()' *ngIf='jobDutiesDescription.length > 100'>{{ !showFullText ? 'show more' : 'show less'}}</span>
</span>
